import type { Security } from '../securities/securitiesTypes';
import type { InvestmentQuoteTypeV2, InvestmentQuoteV2 } from './investmentQuotesV2Types';

type QuoteLookupEntry = Pick<InvestmentQuoteTypeV2, 'symbol' | 'relatedSymbol'>;
type QuoteCollection<Quote> = {
  find(predicate: (quote: Quote) => boolean): Quote | undefined;
};

// Quote lists fall back to local securities, which carry no market data.
export function isInvestmentQuote(entry: InvestmentQuoteV2 | Security | null | undefined): entry is InvestmentQuoteV2 {
  return !!entry && 'lastPrice' in entry;
}

export function getQuoteBySymbol<Quote extends QuoteLookupEntry>(
  quotes: QuoteCollection<Quote>,
  symbol: string | null | undefined,
): Quote | undefined {
  let quote = quotes.find((quote) => !!quote.symbol && !!symbol && quote.symbol.toUpperCase() === symbol.toUpperCase());
  if (!quote) {
    quote = quotes.find(
      (quote) => !!quote.relatedSymbol && !!symbol && quote.relatedSymbol.toUpperCase() === symbol.toUpperCase(),
    );
  }
  return quote;
}
